"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benefits = [{
  icon: "🌍",
  title: "Глобальный кругозор",
  description: "Общайтесь с участниками со всего мира и получайте международные перспективы на лидерство, политику и глобальное развитие."
}, {
  icon: "🎓",
  title: "Учёба у мировых экспертов",
  description: "Вдохновляющие выступления опытных политиков, лидеров отрасли и мыслителей на интерактивных сессиях."
}, {
  icon: "🤝",
  title: "Мощный нетворкинг",
  description: "Расширяйте профессиональную сеть контактов, общаясь с молодыми лидерами и организациями из разных стран."
}, {
  icon: "💡",
  title: "Практические знания",
  description: "Новые идеи, стратегии и практические инструменты для создания реального воздействия в вашем сообществе."
}, {
  icon: "🚀",
  title: "Личностный рост",
  description: "Укрепляйте лидерские навыки, уверенность и глобальный взгляд в ходе совместного обучения и практики."
}, {
  icon: "🏆",
  title: "Международное признание",
  description: "Получите мировое признание и станьте частью растущей сети будущих лидеров мировой политики."
}];
export default function WhyChooseUs() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="264180" id="why-choose-us" className="bg-background text-foreground py-20 lg:py-28">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div ref={headerRef} className={`mb-16 max-w-3xl transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <p className="text-primary font-default font-semibold tracking-widest uppercase text-xs mb-4">
            Почему именно FPLS
          </p>
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-foreground leading-tight">
            Зачем участвовать в FPLS Марокко 2026?
          </h2>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 transition-all duration-1000 delay-200 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {benefits.map((benefit, i) => <div key={i} data-index={i} className="bg-card text-card-foreground p-8 rounded-lg shadow-md hover:shadow-xl border-l-4 border-transparent hover:border-secondary transition-all duration-300 flex flex-col h-full">
              <div className="text-4xl mb-6 select-none">{benefit.icon}</div>
              <h3 className="font-default text-xl font-bold mb-4 text-foreground">
                {benefit.title}
              </h3>
              <p className="text-muted-foreground font-default text-sm leading-relaxed flex-grow">
                {benefit.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}